<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">护理排班编辑</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="editForm" :rules="rules" ref="editForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="护理排班时间"  required prop="time">
                                    <el-date-picker
                                        v-model="editForm.time"
                                        type="date"
                                        placeholder="选择日期"
                                        value-format="yyyy-MM-dd"
                                        disabled
                                        :picker-options="pickerOption"
                                        style="width:100%">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="护理排班类型"  required prop="type">
                                    <el-select v-model="editForm.type" placeholder="" @change="selectType" style="width:100%">
                                        <el-option
                                                v-for="(item,i) in typeValue"
                                                :key="i"
                                                :label="item"
                                                :value="i">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" class="item" v-if="isRemarks()">
                                <el-form-item label="备注" required prop="remarks">
                                    <el-input v-model="editForm.remarks" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
                                </el-form-item> 
                            </el-col>
                            <el-col :span="24" class="item">
                                <el-card class="box-card" shadow='never'>
                                    <div slot="header" class="clearfix">
                                        <span>{{schedulName1}}</span>
                                    </div>
                                    <el-col :span="12" class="item">
                                        <el-form-item label="护士"  required prop="nurseCodeArr1">
                                            <el-select
                                                v-model="editForm.nurseCodeArr1"
                                                multiple
                                                style="width:100%"
                                                filterable
                                                placeholder="请选择护士">
                                                <el-option
                                                    v-for="item in nurseList"
                                                    :key="item.nurseCode"
                                                    :label="item.name"
                                                    :value="item.nurseCode">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12" class="item">
                                        <el-form-item label="护工"  required prop="nurseAideCodeArr1">
                                            <el-select
                                                v-model="editForm.nurseAideCodeArr1"
                                                multiple
                                                style="width:100%"
                                                filterable
                                                placeholder="请选择护工">
                                                <el-option
                                                    v-for="item in nurseAideList"
                                                    :key="item.nurseAideCode"
                                                    :label="item.name"
                                                    :value="item.nurseAideCode">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-card>
                            </el-col>
                            <el-col :span="24" class="item">
                                <el-card class="box-card" shadow='never'>
                                    <div slot="header" class="clearfix">
                                        <span>{{schedulName2}}</span>
                                    </div>
                                    <el-col :span="12" class="item">
                                        <el-form-item label="护士"  required prop="nurseCodeArr2">
                                            <el-select
                                                v-model="editForm.nurseCodeArr2"
                                                multiple
                                                style="width:100%"
                                                filterable
                                                placeholder="请选择护士">
                                                <el-option
                                                    v-for="item in nurseList"
                                                    :key="item.nurseCode"
                                                    :label="item.name"
                                                    :value="item.nurseCode">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12" class="item">
                                        <el-form-item label="护工"  required prop="nurseAideCodeArr2">
                                            <el-select
                                                v-model="editForm.nurseAideCodeArr2"
                                                multiple
                                                style="width:100%"
                                                filterable
                                                placeholder="请选择护工">
                                                <el-option
                                                    v-for="item in nurseAideList"
                                                    :key="item.nurseAideCode"
                                                    :label="item.name"
                                                    :value="item.nurseAideCode">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-card>
                            </el-col>
                            <el-col :span="24" class="item" v-if="editForm.type>0">
                                <el-card class="box-card" shadow='never'>
                                    <div slot="header" class="clearfix">
                                        <span>{{schedulName3}}</span>
                                    </div>
                                    <el-col :span="12" class="item">
                                        <el-form-item label="护士"  required prop="nurseCodeArr3">
                                            <el-select
                                                v-model="editForm.nurseCodeArr3"
                                                multiple
                                                style="width:100%"
                                                filterable
                                                placeholder="请选择护士">
                                                <el-option
                                                    v-for="item in nurseList"
                                                    :key="item.nurseCode"
                                                    :label="item.name"
                                                    :value="item.nurseCode">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12" class="item">
                                        <el-form-item label="护工"  required prop="nurseAideCodeArr3">
                                            <el-select
                                                v-model="editForm.nurseAideCodeArr3"
                                                multiple
                                                style="width:100%"
                                                filterable
                                                placeholder="请选择护工">
                                                <el-option
                                                    v-for="item in nurseAideList"
                                                    :key="item.nurseAideCode"
                                                    :label="item.name"
                                                    :value="item.nurseAideCode">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-card>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">编辑</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Add',
        props:['nurseList','nurseAideList'],
        data() {
            return {
                loading: false,
                floor:null,
                schedulName1:'白班',
                schedulName2:'夜班',
                schedulName3:'晚班',
                typeValue:['两班制','三班制'],
                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    time:'',
                    status:0,
                    nursingSchedulingCode:'',
                    type:0,
                    nurseCodeArr1:[],
                    nurseCodeArr2:[],
                    nurseCodeArr3:[],
                    nurseAideCodeArr1:[],
                    nurseAideCodeArr2:[],
                    nurseAideCodeArr3:[],
                    schedulingPlan:[],
                    remarks:null
                },
                pickerOption: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    },
                },
                rules:{
                    time:[
                        { required: true, message: '请选择时间', trigger: 'blur' },
                    ],
                    type:[{required: true, message: '请选择护理排班类型', trigger: 'blur' }],
                    nurseCodeArr1:[{ required: true, message: '请选择护士', trigger: 'blur' }],
                    nurseCodeArr2:[{ required: true, message: '请选择护士', trigger: 'blur' }],
                    nurseCodeArr3:[{ required: true, message: '请选择护士', trigger: 'blur' }],
                    nurseAideCodeArr1:[{ required: true, message: '请选择护工', trigger: 'blur' }],
                    nurseAideCodeArr2:[{ required: true, message: '请选择护工', trigger: 'blur' }],
                    nurseAideCodeArr3:[{ required: true, message: '请选择护工', trigger: 'blur' }],
                    remarks:[
                        { required: true, message: '请填写备注', trigger: 'blur' },
                    ],
                }
            }
        },

        methods: {
            init(row){
                this.loading = false;
                this.$refs.editForm.resetFields();
                this.editForm.type = row.type-2;
                this.editForm.time = row.time;
                this.editForm.remarks = row.remarks;
                this.editForm.nursingSchedulingCode = row.nursingSchedulingCode;
                if(row.type==2){
                    var DaytimeList=this.getNurseCode(row.nursingSchedulingDaytime.nursingSchedulingDaytimeItemList)
                    this.editForm.nurseCodeArr1=DaytimeList.list1
                    this.editForm.nurseAideCodeArr1=DaytimeList.list2
                    var Nighttime=this.getNurseCode(row.nursingSchedulingNighttime.nursingSchedulingNighttimeItemList)
                    this.editForm.nurseCodeArr2=Nighttime.list1
                    this.editForm.nurseAideCodeArr2=Nighttime.list2
                    
                }else{
                    var Morning=this.getNurseCode(row.nursingSchedulingMorning.nursingSchedulingMorningItemList)
                    this.editForm.nurseCodeArr1=Morning.list1
                    this.editForm.nurseAideCodeArr1=Morning.list2
                    var Noon=this.getNurseCode(row.nursingSchedulingNoon.nursingSchedulingNoonItemList)
                    this.editForm.nurseCodeArr2=Noon.list1
                    this.editForm.nurseAideCodeArr2=Noon.list2
                    var Night=this.getNurseCode(row.nursingSchedulingNight.nursingSchedulingNightItemList)
                    this.editForm.nurseCodeArr3=Night.list1
                    this.editForm.nurseAideCodeArr3=Night.list2
                }
            },
            isRemarks(){
                if(this.editForm.time){
                    var time=timefilters(this.editForm.time).slice(0,10)
                    var nowTime=timefilters(new Date()).slice(0,10)
                    if(time==nowTime){
                        return true
                    }
                }
                return false
            },
            getNurseCode(array){
                var listAll={list1:[],list2:[]}
                for(var i in array){
                    if(array[i].nurseCode){
                        listAll.list1.push(array[i].nurseCode)
                    }
                    if(array[i].nurseAideCode){
                        listAll.list2.push(array[i].nurseAideCode)
                    }
                }
                return listAll
            },
            closeSelf() {
                this.$emit("closeEdit");
            },
            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        if(this.editForm ==""){
                            this.$message({type: 'info', message: '菜单不能为空'});
                            return ;
                        }
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },
            selectType(e){
                if(e==1){
                    this.schedulName1='早班'
                    this.schedulName2='中班'
                }else{
                    this.schedulName1='白班'
                    this.schedulName2='夜班'
                }
            },
            addSubmit(){
                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }
                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.editForm.schedulingPlan=[];
                this.editForm.schedulingPlan.push({nurseCodeArr:this.editForm.nurseCodeArr1,nurseAideCodeArr:this.editForm.nurseAideCodeArr1})
                this.editForm.schedulingPlan.push({nurseCodeArr:this.editForm.nurseCodeArr2,nurseAideCodeArr:this.editForm.nurseAideCodeArr2})
                if(this.editForm.type>0){
                    this.editForm.schedulingPlan.push({nurseCodeArr:this.editForm.nurseCodeArr3,nurseAideCodeArr:this.editForm.nurseAideCodeArr3})
                }
                this.editForm.type=this.editForm.type+2
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"NursingScheduling/Edit",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width:800px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body /deep/ .el-card__body{
                padding: 20px 0;
            }
            .box-card{
                margin: 10px 0;
            }
            .dishesPlanAdd{
                float: right;transform: translate(0px, -9px);
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 60vh;
                overflow-y: auto;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
